import { render, staticRenderFns } from "./LLZ801_Result.vue?vue&type=template&id=08fa63ab&"
import script from "./LLZ801_Result.vue?vue&type=script&lang=js&"
export * from "./LLZ801_Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports